import React from 'react';
import Header from './Header';
import TabelasPrecosPage from './TabelasPrecosPage';

function MenuProdutosPage({ usuario, empresaSelecionada, cardsProdutos, handleVoltar, handleSair }) {
  const [paginaTabelas, setPaginaTabelas] = React.useState(false);
  if (paginaTabelas) {
    return <TabelasPrecosPage usuario={usuario} empresa={empresaSelecionada} onVoltar={() => setPaginaTabelas(false)} onSair={handleSair} />;
  }
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={handleVoltar}
        onSair={handleSair}
      />
      <div className="flex flex-col items-center justify-center mt-16">
        <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-3xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-8">Produtos</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full">
            {cardsProdutos.map(card => {
              if (card.nome === 'Tabelas') {
                return (
                  <div
                    key={card.nome}
                    className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                    onClick={() => setPaginaTabelas(true)}
                  >
                    {card.icon}
                    <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
                  </div>
                );
              }
              return (
                <div
                  key={card.nome}
                  className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                  onClick={card.onClick}
                >
                  {card.icon}
                  <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MenuProdutosPage; 